import { useTranslation } from 'next-i18next';
import { Box, ButtonV2 as Button } from '@bridebook/ui';
import SignupLink from '@bridebook/web/app-shared/components/signup-link/signup-link';
import ReviewsComp from '@bridebook/web/app-basic/components/supplier/sections/reviews/reviews';

const Reviews = () => {
  const { t } = useTranslation('supplier');

  return (
    <SignupLink
      clickedSection="reviewsAndTestimonials"
      clickedLocation="supplierProfile"
      cta="reviewsAndTestimonials">
      <ReviewsComp />
      <Box alignItems="center">
        <Button styleWrapper={{ width: 'auto', marginTop: '-24px', marginBottom: '48px' }}>
          {t('supplier.accordion.reviews.button.viewSignUp')}
        </Button>
      </Box>
    </SignupLink>
  );
};

export default Reviews;
